import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createButton: {
		id: 'issue-create.common.footer.create-button',
		defaultMessage: 'Create',
		description: 'Label for create button in issue create modal',
	},
	createButtonInMiniView: {
		id: 'issue-create.common.footer.create-button-in-mini-view',
		defaultMessage: 'Create',
		description: 'Label for create button in issue create mini view',
	},
	cancelButton: {
		id: 'issue-create.common.footer.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Label for cancel button in issue create modal',
	},
	discardButton: {
		id: 'issue-create.common.footer.discard-button',
		defaultMessage: 'Discard',
		description: 'Label for discard button in issue create ai-enabled view',
	},
	createAnother: {
		id: 'issue-create.common.footer.create-another',
		defaultMessage: 'Create another',
		description: 'Label for create another checkbox in issue create modal',
	},
	createAnotherToBeFaded: {
		id: 'issue-create.common.footer.create-another-to-be-faded',
		defaultMessage: 'Create another issue',
		description:
			'Label for create another checkbox in issue create modal before issue terminology refresh',
	},
	copyToNextIssue: {
		id: 'issue-create.common.footer.copy-to-next-issue',
		defaultMessage: 'Copy to next issue',
		description: 'Label for create another toggle in issue create modal',
	},
	issuesCreatedLink: {
		id: 'issue-create.common.footer.issues-created-link',
		defaultMessage: '{issueCount} {issueCount, plural, one {issue} other {issues}} created',
		description: 'Label for link which takes user to GIN with created issues',
	},
	createDropdownOptionCreateAnother: {
		id: 'issue-create.common.footer.create-dropdown-option-create-another',
		defaultMessage: 'Create and start another',
		description: 'Label for option in create split button for create another issue',
	},
	createDropdownOptionCopy: {
		id: 'issue-create.common.footer.create-dropdown-option-copy',
		defaultMessage: 'Create and copy',
		description: 'Label for option in create split button for create and copy issue',
	},
	toggleOnTooltip: {
		id: 'issue-create.common.footer.toggle-on-tooltip',
		defaultMessage: 'Toggle off to finish creating issues.',
		description: 'tooltip content when toggle is on',
	},
	toggleOffTooltip: {
		id: 'issue-create.common.footer.toggle-off-tooltip',
		defaultMessage:
			'After selecting {createButton}, immediately start a new issue with these details and fields.',
		description: 'tooltip content when toggle is off',
	},
});
